import { render, staticRenderFns } from "./OrderItemMenu.vue?vue&type=template&id=7fb9984c&"
import script from "./OrderItemMenu.vue?vue&type=script&lang=js&"
export * from "./OrderItemMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports